/* src/app/dynamic-forms/tool-bar/tool-bar.component.scss */
.desc {
  width: 15%;
  padding: 6px;
  text-align: center;
  color: var(--tem-muted);
}
.flex-spacer {
  flex-grow: 1;
}
.filter-field {
  width: -webkit-fill-available;
  padding: 6px;
}
.view-component-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.vl {
  border-left: 1px solid var(--tem-border);
  height: 24px;
  margin-left: 5px;
  margin-right: 5px;
}
.menu-label {
  margin-left: var(--tem-space-2);
}
/*# sourceMappingURL=tool-bar.component.css.map */
